import React, {useState, useEffect, useRef} from 'react';
import Navbar from "../../Components/Navbar";
import { Spinner  } from "react-awesome-spinners";
import CidadeJson from "../../JSONS/cidadejson";
import InstitutoJson from "../../JSONS/institutojson";
import TipocontaJson from "../../JSONS/tipocontjson";
import MenusJson from "../../JSONS/Menus";
import SweetAlert from 'react-bootstrap-sweetalert';
import Api from '../../Api';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import cheerio from 'cheerio';
import ChatIntro from '../../Components/ChatIntro';
import TopoSite from '../../Components/SiteTopo';
import SobreMim from '../../Components/SobreMim';
import SiteMeio2 from '../../Components/SiteMeio2';
import SiteMeio3 from '../../Components/SiteMeio3';
import SiteMeio4 from '../../Components/SiteMeio4';
import SiteMeio5 from '../../Components/SiteMeio5';
import Rodape from '../../Components/Rodape'
import Contato from '../../Components/contato';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import {Carousel} from '3d-react-carousal';
//import TouchCarousel from 'react-touch-carousel'
import SiteParte8 from '../../Components/SiteParte8';
// import Carrossel from 'react-elastic-carousel';
//import { Carousel } from 'react-responsive-carousel';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import "react-alice-carousel/lib/alice-carousel.css";
import Butao from "../../Components/Butao";
import Butao2 from "../../Components/Butao2";
import { FaBars, FaTimes } from "react-icons/fa";
import "../../Styles/main.css"
import Modal from 'react-awesome-modal';


export default ({Visitante, DadEmp, setConta, setEmail, Email, Senha, setSenha, 
  Confirsenha, setConfirsenha, Cidade, setCidade, Estado, 
  setEstado, Instituicao, setInstituicao, Nome, setNome, 
  Telefone, setTelefone,  ContaTipo, setContaTipo,
   Loading, cadastrando, logando, Alert, setAlert, NomeGuerra, setNomeGuerra,
   Patente, setPatente, Bo, setLoading, setIdUser}) => {

    const captcha = useRef(null)
    const navRef = useRef();

           

          const [EstCidJson, setEstCidJson] = useState({CidadeJson});
          const [ListaEstado, setListaEstado] = useState([]);
          const [ListaCidade, setListaCidade] = useState([]);
          const [ListInst, setListInst] = useState(InstitutoJson.Intituicao);
          const [ListContaTipo, setListContaTipo] = useState(TipocontaJson.tipo);   
          const [VerManual, setVerManual] = useState(false);
          const [VerContato, setVerContato] = useState(false);
          const [CadasPag, setCadasPag] = useState(false);
          const [EsqSenhaServ, setEsqSenhaServ] = useState(false);
          const [CodLast, setCodLast] = useState(0);
          const [Tel, setTel] = useState("");
          const [Carreg, setCarreg] = useState(false);
          const [Cadast, setCadast] = useState(false);
          const [CodG, setCodG] = useState(false);
          const [Robo, setRobo] = useState(true);
          const [Tentativa, setTentativa] = useState(0)
          const [ItensGeral, setItensGeral] = useState([])
          const [ListaItens, setListaItens] = useState([])
          const [Tag, setTag] = useState("");
          const [Menu, setMenu] = useState("");
          const [ModalVer, setModalVer] = useState(false);
          const [Quant, setQuant] = useState(1)
          const [ListPed, setListPed] = useState([])
          const [Mesa, setMesa] = useState("")
          const [Letra, setLetra] = useState(["", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "X", "Z"]);
          const [Slides, setSlides] = useState([])
            const [Items, setItems] = useState([
              {id: 1, title: 'item #1'},
              {id: 2, title: 'item #2'},
              {id: 3, title: 'item #3'},
              {id: 4, title: 'item #4'},
              {id: 5, title: 'item #5'}
            ])
            const [MesaVer, setMesaVer] = useState("")
            const [Alf, setAlf] = useState(1)
            const [Nometext, setNometext] = useState("Pois quero um pastel de calabresa e um suco de morango ")
           console.log(DadEmp)
            useEffect(() => {
              ImgMerk();
            }, []);

            
            useEffect(async () => {
              EntrandoLinks();                        
            }, []);
            
                  useEffect(() => {
                    ListandoEstado();
                  }, []);

                  useEffect(() => {
                    MenusItensVer()
                  }, [Tag]);
              
                  useEffect(() => {
                    console.log(MesaVer);
                }, [MesaVer]);
            
                  useEffect(() => {
                        ListandoItens();
                    }, [ItensGeral]);

                    useEffect(() => {
                      if( Email.length === 14){
                   
                          //TelWhats();
                          //setLoading(true)
                      }
                      
                     }, [Email])

                       const MenusItensVer = async ()=>{
                          if (navigator.onLine) {
                            setCarreg(true)
                            await Api.MenusItens(Email, Tag, Menu,  setItensGeral, setCarreg  );
                          
                          } else {
                           
                          }

                            
                        }
                        const  ListandoItens = ()=>{
                          setListaItens(ItensGeral)
                        }

                     const TelWhats = ()=>{
                      setLoading(true)
                    //  Api.VerWhats(Tel, setTelMsg, setNome, setBtn, setLoading)
                    //  Api.AnaliseTel(Tel, setTe1, setNome)  
                    }

                    const EntrandoLinks = () => {
                      const Site = window.location.href;
                    const VerSite =  Site.split("/");
                    console.log(VerSite);
                    console.log(VerSite[3]) 
                    if(VerSite[3] === "Pedido"){
                      setMesaVer(VerSite[4])
                     
                    } else  if(VerSite[3] === ""){
                      setMesaVer("Externo")
                    }   
                     
                    }

                    const ImgMerk = ()=> {
                      var resL=[]
                   
                      //  for(let i in DadEmp.Marketing){
                      //   if(DadEmp.Marketing[i].Ativo === true){
                      //     resL.push(<img  src={DadEmp.Marketing[i].Img} alt="1"/>)
                      //   }
                      //  }
                      //  setSlides(resL)

                    }

                    const onChange = ()=> {
                      if(captcha.current.getValue()){
                        setRobo(false)
                      }
                    }
                    const IrWhats = ()=>{
                      window.open(`https://wa.me/+5599984136843?text=`, '_blank');
                      // var ver = DadEmp.numero.replace("(", "55");
                      // var par1 = ver.replace(")", "");
                      // var par2 = par1.replace(" ", "");
                      // var par3 = par2.replace("-", "");
                      //  console.log(par3)
                      // window.open(`https://wa.me/${par3}?text=Ola`, '_blank');
                    }

                    const IrInst = ()=>{

                     window.open(`${DadEmp.Redes.Instagram.Link}`, '_blank');
                    }

                    const IrFace = ()=>{

                      window.open(`${DadEmp.Redes.Facebook.Link}`, '_blank');
                    }

                    const IrLoc = ()=>{
                      window.open(`https://wa.me/+5599984136843?text=`);
                     // window.open(`${DadEmp.Redes.Localizacao.Link}`, '_blank');
                    }

                    const EnviandoPedido = ()=>{
                      var ver = DadEmp.numero.replace("(", "55");
                      var par1 = ver.replace(")", "");
                      var par2 = par1.replace(" ", "");
                      var par3 = par2.replace("-", "");
                      var NumAlf = Alf+1;
                      var Codig = Letra[Alf]+Visitante
                      
                      var Msg = "" ;

                      Msg = Msg + `Mesa:%20${MesaVer}%0A`
                      Msg = Msg + `Código:%20${Codig}%0A`
                      for(let i in ListPed){
                      Msg = Msg + `Item:%20${ListPed[i].Nome}%0A`
                      Msg = Msg + `Quantidade:%20${ListPed[i].Quant}%0A`
                      if(isNaN(ListPed[i].Descont) && ListPed[i].Descont !==0){
                        Msg = Msg + `Preco:%20${ListPed[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}%0A`
                      }else {
                        Msg = Msg + `Preco:%20${ListPed[i].Preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}%0A`
                        Msg = Msg + `Desconto:%20${ListPed[i].Descont.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}%0A`
                      }
                      
                      Msg = Msg + `----------------------------%0A`
                      }
                     
                      
                      
                     window.open(`https://wa.me/${par3}?text=${Msg}`, '_blank');
                      Api.EnviandoPedidoEmp( MesaVer, Codig, ListPed, setListPed, setModalVer)
                      setAlf(NumAlf)
                    }

                          const Entrarpainel= () => {
                            setConta("45564556");
                          }

                          function ListandoEstado() {
                            let list = [] ;
                            EstCidJson.CidadeJson.estados.forEach(result => {
                                  list.push({
                                      select: result.nome,
                                      cidades: result,
                                  });   
                            });
                            setListaEstado(list);
                          }

                          function ListandoCidade() {
                              for(let i in ListaEstado ) {
                                  let listanha = [];
                                  if(ListaEstado[i].cidades.nome === Estado) {
                                    ListaEstado[i].cidades.cidades.forEach(result => {
                                      listanha.push({
                                        select: result,   
                                    });   
                                    });
                                    setListaCidade(listanha);
                                  }
                              }
                            }
                            function confirma() {
                              setAlert(" ");
                            }
                            function cancelar() {
                              setAlert(" ");
                            }

                            function recuperarSenha() {
                              setEsqSenhaServ(true);
                            }

                            // function betfair () {
                            //    new sportApi('betfair', { getCommonContents: false });
                            // }

                            const GerarCod =  async ()=> {

                              axios.get(`/users`).then(
                                resp=>{

                                  let dede = resp.data;
                               
                                  const $ = cheerio.load(dede);
                                    const tudo = $("*").html();
                                    console.log(tudo);
                                }
                               )

             // var cors  = "https://cors-anywhere.herokuapp.com/"
             // var taget = "https://www.google.com"


            //   var url = `/users`;
            //  fetch(url).then(response =>response.text())
            //            .then(resul =>scraping(resul, "text/html"))
            //            .catch(error=> console.error("|Error: "+ error))
            
            // function scraping(string_html, content_type){
            //   let parser = new DOMParser();
            //   let doc = parser.parseFromString(string_html, content_type )
              
            //   const $ = cheerio.load(doc);
            //   const tudo = $("*").html()
            //   console.log(tudo)
            // };


            //  axios.get(url).then(
            //   resp=>{
            //     console.log(resp.data)
            //   }
            //  )

                            // if(Robo === false){
                            //   setLoading(true)
                            //   Api.Entrando1(Email, setIdUser, setNome, setLoading, setCodLast, setCadast, setCodG, setAlert);
                            // } else {
                            //   setAlert("Por Favor Clique em NÃO SOU ROBÔ!");
                            // }
                           
                              
                           
                             
                            }

                            const VerOlds = ()=>{
                             const url = 'https://api-football-v1.p.rapidapi.com/v3/odds?date=2022-09-13&page=1';
                              // const url = 'https://api-football-v1.p.rapidapi.com/v3/leagues?id=239&season=2022'
                                          const options = {
                                            method: 'GET',
                                            headers: {
                                              'X-RapidAPI-Key': '54f23e58f0msh34be965c7c7eac7p16fe9ejsne8979eb650eb',
                                              'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
                                            }
                                          };
                                          
                                          fetch(url, options)
                                            .then(res => res.json())
                                            .then(json => console.log(json))
                                            .catch(err => console.error('error:' + err));
                            }

                            const EntrandoCont =  async ()=> {
                              if(Nome !== ""){
                              if(Senha !== ""){
                              if(parseInt(Senha)  === CodLast){
                                
                                 logando()
                              } else {
                                setTentativa(Tentativa +1)
                                setAlert("Código Errado "+(Tentativa+1)+"° tentativa de 3");
                              }
                              
                              } else {
                                 
                                setAlert("Preencha o Whatsapp");
                              }
                            } else {
                                 
                              setAlert("Preencha o Nome");
                            }
                             
                            }
                            const responsive = {
                              0: {
                                items: 1
                              },
                              600: {
                                items: 1
                              },
                              1024: {
                                items: 1
                              }
                            };
                      
                            const FiltrarMenu = (Tag, Menu)=>{
                              setCarreg(true)
                              setTag(Tag)
                              setMenu(Menu)
                            
                            }
                           const EnviandoItem=(list)=>{
                           console.log(Nometext.length)
                           var DivNome = []
                           for (var i = 0; i <= Nometext.length-3; i++) {
                            console.log(i);
                            DivNome.push(Nometext.toLowerCase().slice(i, (i+3)))
                            
                         }


                           

                            console.log(DivNome)



                            // console.log(list)
                            // setListPed([...ListPed, {id:list.id, Nome:list.nome, Preco:list.PrecoReal, Descont:list.DescontReal, foto:list.foto, Descricao:list.Descricao, Quant:1} ])
                            // setModalVer(true)
                           }
                           const TirarEsse = (position) =>{
                            setListPed([...ListPed.filter((item, index) => index !== position)]);
                           
                          }

                          const Quantificando = (position, Num) =>{
                            setQuant(Num)
                            ListPed[position].Quant = Num 
                            setListPed(ListPed)
                          }
                            
                              const showNavbar = () => {
                                navRef.current.classList.toggle("responsive_nav");
                              };
   
    return (
     
          <section className="content">
                
                <Modal visible={ModalVer} width="300" height="400" effect="fadeInUp" onClickAway={() =>setModalVer(false)}>
                <div  className="modaldiv">
                <div  className="CaixadeapostaTitulo" >
                    <h5>Pedido</h5> <div onClick={() =>setModalVer(false)}  className="fechaModal"><a href="javascript:void(0);" style={{color: "inherit", }} >X</a></div>
                    </div>
                    
                    {ListPed.map((item3, index)=>( 
                      <>
                      <div  className="Caixadeaposta" >
                       <string style={{color:"#fff", fontSize:18, marginLeft: 10}}>{item3.Nome}</string><br/>
                 
                 <string style={{color:"#fff", marginLeft: 10}}>Quant: </string><br/>
                 <div style={{width:60, marginBottom:10, marginLeft: 10}}>
                 <input 
                    type="number" 
                    className="form-control" 
                    placeholder="Digite a quantidade" 
                    value={ ListPed[index].Quant}
                    onChange={t=>Quantificando(index, parseInt(t.target.value))}
                    />
                    </div>
                    
                 <a className="btn btn-danger ExcluirJogo" onClick={()=>TirarEsse(index)}>
                        <i class="fas fa-trash"></i> 
                         </a> 
                         </div>
                      </>
                     
                        ))} 
                     
                     <Butao 
                              onClick={()=>EnviandoPedido()}
                              text={"Enviar Pedido"}
                              />    
                 
                </div>
                
                  </Modal> 
                <div className="row">
                  <section className="col-12">
                  {Loading === true ?
                        <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                        :
                        <>
                          {/* Inicio de Menu */}
                                  <header>
                    <img className='imagem_topMenu' src='../../assets/logoMy1.png' style={{ }} alt="" />
                        <img className='imagem_top25Menu' src='../../assets/logoMy2.png' style={{ }} alt="" />
                    <nav ref={navRef}>
                    {ItensGeral.map((item, key)=>(
                      <>
                      <AnchorLink href={item.Ref} >  
                    <a onClick={showNavbar}>{item.nome}</a>
                        </AnchorLink> 
                    </>
                      ))}
                        <AnchorLink href="#Localização" >  
                    <a onClick={showNavbar}>Informações</a>
                        </AnchorLink> 
                    
                    
                      
                    
                      <button
                        className="nav-btn nav-close-btn"
                        onClick={showNavbar}>
                        <FaTimes />
                      </button>
                    </nav>
                    <button className="nav-btn" onClick={showNavbar}>
                      <FaBars />
                    </button>
                  </header>
           {/* Fim de Menu */}
                     
                     
                      {/* <TopoSite /> */}
                   
                    
                     
               
               <div className="col-sm-12"  style={{ marginTop:60, paddingBottom:30, display:"flex", justifyContent:"center", alignItems:"center"}}  >
                </div>
               <Carousel slides={Slides} autoplay={true} interval={3000}/>  


              {/* Inicio Da Vitrine */}
              {ItensGeral.map((item, key)=>(
				      <>
         
          <div id={item.nome}>
              
              <div className="col-sm-12" style={{backgroundColor:"#fff",   display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column",}} >
              
              <div className="SiteParte" >
          
          <h1 style={{color:"#000"}}>{item.nome}</h1>
          <div className="Bordatitulo2" style={{marginLeft:-50}}>

          </div>
          <h2>Escolha Sua {item.nome}</h2>
          
               </div>
               <div style={{width:"80%",  display:"flex", flexDirection:"row", flexWrap:"wrap"  }}>
               {item.Tags.map((Tags, key)=>(
                <div onClick={()=>FiltrarMenu(Tags, item.nome )} style={{fontSize: 15, color:"#fff",  height:30, padding:10,  backgroundColor:"#000", margin:2, display:"flex", justifyContent:"center", alignItems:"center" }} >
                  {Tags}
                </div>
                 ))}
                <div onClick={()=>FiltrarMenu("", "" )} style={{fontSize: 15, color:"#fff",  height:30, padding:10,  backgroundColor:"#ccc", margin:2, display:"flex", justifyContent:"center", alignItems:"center" }} >
                  Limpar
                </div>
             
               </div>
                    <div  className="row" style={{backgroundColor:"#ccc", width:"80%"}}>
                    {Carreg === true ?
                     <>
                     <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                     </>
                    :
                    <>
                      {item.ListaItens.map((list, key)=>(
                <div className="col-sm-4" >
                <div className="SiteParteInt"   >
                
                    <div style={{ width:180, height:300, backgroundColor:"#fff", borderRadius:20, borderColor:"#fff", borderWidth:5, borderStyle:"solid", display:"flex", flexDirection:"column", alignItems:"center", padding:10, marginBottom:10, marginRight:10}}>
                              <img  src={list.foto} alt=""   style={{ width:150, height:100, borderRadius:20, resize:"horizontal"}} />
                              <div className="TextInt"> 
                              <h1>{list.nome.substring(0,20)}</h1>
                              {list.DescontReal?
                              <>
                                <h2><s style={{color:"red"}}>{list.PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</s></h2>
                                <h2>{list.DescontReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</h2>
                              </>
                              :
                                <>
                                  <h2>{list.PrecoReal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</h2>
                                </>

                              }
                            
                              <h2>{list.Descricao}</h2>
                              </div>
                              <Butao 
                              onClick={()=>EnviandoItem(list)}
                              text={"Enviar Item"}
                            />
                     
                    </div>
               </div>
               </div>
                 ))}
                    
                    </>

                    }
                  
                 
                
                    
                  
                            
                    </div>
          
              </div>
       </div>
		  </>
      
				 ))}
             
               <div className="col-sm-12"  style={{ marginTop:80, paddingBottom:30, display:"flex", justifyContent:"center", alignItems:"center"}}  >
             
              
               {/* <AliceCarousel
                infinite={true}
              duration={40}
              autoPlay={true}
              swipeDisabled={false}
              dotsDisabled={true}
              startIndex = {1}
              fadeOutAnimation={true}
              keysControlDisabled={true}
              mouseDragEnabled={true}
              playButtonEnabled={true}
              responsive={responsive}
              autoPlayInterval={2000}
              autoPlayDirection="rtl"
              autoPlayActionDisabled={true}
              showSlideIndex={false}
            
            >
          <img  src="assets/Comida1.png" alt="1" style={{width:1290, height:400 }}/>
            <img  src="assets/Comida2.png" alt="1" style={{width:1290, height:400 }}/>
            <img  src="assets/Comida3.png" alt="1" style={{width:1290, height:400 }}/>
          
      </AliceCarousel> */}
    
                
                
             
    
                   

                      </div>
                         
                         


                           <div id="Localização">
                           <div className="col-sm-12" style={{backgroundColor:"#fff",   display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column",}} >

                              <div className="SiteParteMaps">
                                    <h1 >Informações</h1>
                                  <div className="Bordatitulo2"></div>
                                  <div style={{display:"flex", padding:10, flexDirection:"row",   alignItems:"center", justifyContent:"center", marginLeft:40, marginRight:80 }}>
                                  {DadEmp.Redes &&
                          <>
                          {DadEmp.Redes.Facebook.Ativo &&
                        <div onClick={()=>IrFace()}  >
                                            
                        <img  src='../../assets/FaceCart.png' style={{width:30, height:30, marginRight:10 }} alt="" />
                        
                        </div>
                          }
                        {DadEmp.Redes.Instagram.Ativo &&
                        <div onClick={()=>IrInst()}  >
                        
                        <img  src='../../assets/InstCar.png' style={{width:30, height:30, marginRight:10}} alt="" /> 
                        
                      
                        </div>
                        }
                         {DadEmp.Redes.Localizacao.Ativo &&
                        <div onClick={()=>IrLoc()} >
                        
                        <img  src='../../assets/GpsCar.png' style={{width:30, height:30, marginRight:10}} alt="" />   
                        
                      
                        </div>
                          } 
                          </>
                          }
                          <div onClick={()=>IrWhats()}  >
                        
                          <img  src='../../assets/WhatCar.png' style={{width:30, height:30, marginRight:10}} alt="" /> 
                          
                        
                          </div>
                                </div>
                                <string style={{fontSize:20}}>Horário de Funcionamento</string>
                                {DadEmp.Funcionamento &&
                                  <>
                                    {DadEmp.Funcionamento.map((item, key)=>(
                                  <>
                                  {item.Ativo ?
                                    <string style={{fontSize:15}}>{item.Dia} {item.Abertura} ás {item.Fechamento}</string>
                                    :
                                    <string style={{fontSize:15}}>{item.Dia} Não Funciona</string>
                                  }
                                  
                               

                                 </>
                                 ))}
                                    </>
                                    }
                              
                                  
                              </div>
                              
                              </div>
                          </div> 
                          <div id="Rodape">
                          <div  onClick={()=>setConta("Admin")} className="col-sm-12" style={{backgroundColor:"#fff", marginTop:0,  display:"flex", justifyContent:"space-between", flexDirection:"row", flexWrap:"wrap" }} >
                              <div style={{display:"flex", padding:10, marginLeft:40, flexDirection:"row", backgroundColor:"#fff", alignItems:"center", justifyContent:"center",  }}>
                          
                          <img className='imagem_topMenu' src='../../assets/logoMy1.png' style={{ }} alt="" />    
                          <h5 style={{fontSize:15, marginLeft:10 }}><span style={{fontWeight:"bold" }} >ADMIN</span> </h5>
                          </div>
                          <div style={{display:"flex", width:200, padding:10, flexDirection:"column",   alignItems:"center", justifyContent:"center", marginLeft:40, marginRight:80 }}>
                        
                          
                            <h5 style={{fontSize:15, }}>Desenvolvido pelo <span style={{fontWeight:"bold" }} >CWO</span> . Todos os direitos resevados.</h5>
                          </div>
                          <div style={{display:"flex", padding:10, flexDirection:"row",   alignItems:"center", justifyContent:"center", marginLeft:40, marginRight:80 }}>
                         
                        
                         
                         
                        
                         
                          {DadEmp.Redes &&
                          <>
                          {DadEmp.Redes.Facebook.Ativo &&
                        <div onClick={()=>IrFace()}  >
                                            
                        <img  src='../../assets/FaceCart.png' style={{width:30, height:30, marginRight:10 }} alt="" />
                        
                        </div>
                          }
                        {DadEmp.Redes.Instagram.Ativo &&
                        <div onClick={()=>IrInst()}  >
                        
                        <img  src='../../assets/InstCar.png' style={{width:30, height:30, marginRight:10}} alt="" /> 
                        
                      
                        </div>
                        }
                         {DadEmp.Redes.Localizacao.Ativo &&
                        <div onClick={()=>IrLoc()} >
                        
                        <img  src='../../assets/GpsCar.png' style={{width:30, height:30, marginRight:10}} alt="" />   
                        
                      
                        </div>
                          } 
                          </>
                          }
                          <div onClick={()=>IrWhats()}  >
                        
                          <img  src='../../assets/WhatCar.png' style={{width:30, height:30, marginRight:10}} alt="" /> 
                          
                        
                          </div>
                         
                         
                         
                          </div>
           
                       </div>
                          </div>
                          {DadEmp.Redes &&
                          <>
                          {DadEmp.Redes.Facebook.Ativo &&
                        <div onClick={()=>IrFace()}  className="FaceBot">
                                              
                        <img className='imagem_top' src='../../assets/FaceCart.png' style={{width:50, height:50 }} alt="" />
                        

                        </div>
                          }
                        {DadEmp.Redes.Instagram.Ativo &&
                        <div onClick={()=>IrInst()}  className="InstBot">
                        
                        <img className='imagem_top' src='../../assets/InstCar.png' style={{width:50, height:50 }} alt="" />
                        
                      
                        </div>
                        }
                           <div onClick={()=>IrInst()}  className="InstBot">
                        
                        <img className='imagem_top' src='../../assets/InstCar.png' style={{width:50, height:50 }} alt="" />
                        
                      
                        </div>
                         {DadEmp.Redes.Localizacao.Ativo &&
                        <div onClick={()=>IrLoc()}  className="GpsBot">
                        
                        <img className='imagem_top' src='../../assets/GpsCar.png' style={{width:50, height:50 }} alt="" />
                        
                      
                        </div>
                          } 
                          </>
                          }
                        
                          <div onClick={()=>IrWhats()}  className="WhatsBot">
                        
                          <img className='imagem_top' src='../../assets/WhatCar.png' style={{width:50, height:50 }} alt="" />
                          
                        
                          </div>
                          <button onClick={()=>setModalVer(true)}  className="NotaJogo">
                         {ListPed.length !== 0 &&
                          <div  className="NotifJogos">{ListPed.length}</div>
                         }
                         
                         <i class="fas fa-edit"></i> <p style={{fontSize: 12 }}>PEDIDO</p>
                    </button>
                   </>
                        }
                    </section>       
               
            </div>
          </section>
       
    );
}